var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Modal from "react-overlays/Modal";
import { Transition } from "react-transition-group";
const TRANSITION_DURATION_MS = 250;
const fadeStyles = {
    entering: 'tr-fade-show',
    entered: 'tr-fade-show',
};
const Fade = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Transition, Object.assign({}, props, { timeout: TRANSITION_DURATION_MS }), (status, innerProps) => React.cloneElement(children, Object.assign(Object.assign({}, innerProps), { className: `tr-fade ${fadeStyles[status]} ${children.props.className}` }))));
};
const growStyles = {
    entering: 'tr-grow-entering',
    entered: 'tr-grow-show',
    exiting: 'tr-grow-exiting',
    exited: 'tr-grow-default'
};
const Grow = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Transition, Object.assign({}, props, { timeout: TRANSITION_DURATION_MS }), (status, innerProps) => {
        return React.cloneElement(children, Object.assign(Object.assign({}, innerProps), { className: `tr-grow ${growStyles[status]} ${children.props.className}` }));
    }));
};
export const CommonModal = ({ isOpen, setIsOpen, children, title, center, icon = "", badge, iconSwapOpacity = false, extraClass = "", onShow, onEnter }) => {
    const Backdrop = (props) => React.createElement("div", Object.assign({}, props, { className: "common-modal-backdrop" }));
    const iconCss = icon == "loading"
        ? "l fa-spinner fa-pulse"
        : "d " + icon + (iconSwapOpacity ? " fa-swap-opacity" : "");
    // const width = 600;
    return React.createElement(Modal, { show: isOpen, backdrop: "static", className: "common-modal-container", renderBackdrop: Backdrop, onBackdropClick: () => setIsOpen(false), onEscapeKeyDown: () => setIsOpen(false), onShow: onShow, transition: Grow, onEnter: onEnter, backdropTransition: Fade, renderDialog: (props) => {
            return React.createElement("div", Object.assign({}, props, { onClick: e => e.stopPropagation() }),
                React.createElement("div", { className: "common-modal-backdrop-click-catcher-hack", onClick: () => setIsOpen(false) }),
                React.createElement("div", { className: "common-modal " + extraClass },
                    React.createElement("button", { className: "common-modal-close", onClick: () => setIsOpen(false) },
                        React.createElement("i", { className: "fas fa-xmark" })),
                    title && React.createElement("div", { className: "common-modal-header" },
                        React.createElement("h2", null,
                            React.createElement("i", { className: "mr-2 fa-fw fa" + iconCss }),
                            title,
                            " ",
                            badge)),
                    React.createElement("div", { className: center ? "text-center" : "" }, children)));
        } });
};
